import React from 'react';
import { FaDownload } from 'react-icons/fa';
import usePWA from '../../hooks/usePWA';

function InstallButton() {
  const { isInstallable, isInstalled, promptInstall } = usePWA();

  if (isInstalled || !isInstallable) return null;

  const handleClick = async () => {
    await promptInstall();
  };

  return (
    <button
      onClick={handleClick}
      title="Installer QuizFoot League"
      style={{
        position: 'fixed',
        top: 12,
        right: 12,
        zIndex: 9999,
        background: 'linear-gradient(135deg, #f0b429, #d4920a)',
        border: 'none',
        borderRadius: '50%',
        width: 44,
        height: 44,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxShadow: '0 4px 15px rgba(240,180,41,0.4)',
        transition: 'all 0.3s ease',
        color: '#0d2b1a',
      }}
      onMouseEnter={(e) => {
        e.target.style.boxShadow = '0 6px 20px rgba(240,180,41,0.6)';
        e.target.style.transform = 'scale(1.1)';
      }}
      onMouseLeave={(e) => {
        e.target.style.boxShadow = '0 4px 15px rgba(240,180,41,0.4)';
        e.target.style.transform = 'scale(1)';
      }}
    >
      <FaDownload size={18} />
    </button>
  );
}

export default InstallButton;
